import { doc, Doc } from 'mostra';
const {
  genDownloadDocUrl,
  uploadDoc,
} = doc;
export {
  Doc,
  uploadDoc,
  genDownloadDocUrl,
};

// import { firebase } from 'mostra';
// // import * as firebase from '@/plugins/firebase';
// import { v4 } from 'uuid';
//
// export type Doc = {
//   id: string | null;
//   fileName: string;
//   fileSize: number | null;
//   description?: string;
//   isApproval: boolean;
// }
//
// export const createDoc = (): Doc => ({
//   id: null,
//   // title: '',
//   fileName: '',
//   fileSize: null,
//   description: '',
//   isApproval: true,
// });
//
// const storageRef = (owner: string, id: string) => firebase.storage()
//   .child('docs')
//   .child(owner)
//   .child(id);
//
// export const genDownloadDocUrl = async (
//   owner: string,
//   id: string,
// ): Promise<string> => {
//   try {
//     const url = await storageRef(owner, id)
//       .getDownloadURL();
//     return url;
//   } catch (error) {
//     return '';
//   }
// };
//
// export const encodeRFC5987ValueChars = (str: string) => encodeURIComponent(str)
//   .replace(/['()]/g, escape) // i.e., %27 %28 %29
//   .replace(/\*/g, '%2A')
//   .replace(/%(?:7C|60|5E)/g, unescape);
//
// export const uploadDoc = async (
//   owner: string,
//   file: File | Blob | Uint8Array,
//   fileName: string,
//   fileSize: number,
//   callback: (snapshot: any) => void,
// ): Promise<Doc> => new Promise((resolve, reject) => {
//   const id = v4();
//   firebase.storage()
//     .child('docs')
//     .child(owner)
//     .child(id)
//     .put(file, {
//       contentDisposition:
//         `inline; filename*=UTF-8''${encodeRFC5987ValueChars(fileName)}`,
//       cacheControl: 'public,max-age=315360000',
//     })
//     .on(
//       'state_changed',
//       (snapshot) => {
//         console.log(snapshot.state);
//         if (callback) callback(snapshot);
//       },
//       (error) => {
//         reject(error);
//       },
//       () => {
//         const doc = createDoc();
//         doc.id = id;
//         doc.fileName = fileName;
//         doc.fileSize = fileSize;
//         resolve(doc);
//       },
//     );
// });
